import { action } from 'satcheljs';
/**
 * Called when there is a change in the default reminder dropdown
 */
var selectReminderDefaultTimeOption = action('selectReminderDefaultTimeOption', function (defaultReminderTime) { return ({
    defaultReminderTime: defaultReminderTime,
}); });
export default selectReminderDefaultTimeOption;
//# sourceMappingURL=selectReminderDefaultTimeOption.js.map